import React, { useContext, useEffect, useState } from 'react';
import Dialog from 'src/components/common/Dialog';
import Button from 'src/components/controls/forms/redesign/FormButton';
import { useForm } from 'react-hook-form';
import RHFInputBox from 'src/components/controls/tempRHFControls/RHFInputBox';
import useFetch from 'use-http';
import TSDILandman from 'src/models/personnel/TSDILandman';
import { AppContext } from 'src/providers/AppContextProvider';
import { IAppContextState } from 'src/reducers/AppContext';
import PersonnelHiringHistory from 'src/models/personnel/PersonnelHiringHistory';
import PersonnelToast from '../components/PersonnelToast';

interface IUpdateTermHireDateDialogProps {
    dialogName: string;
    context: string;
    oldDate: string;
    selectedPersonnel: TSDILandman;
    hideDialog: () => void;
}

const UpdateTermHireDateDialog = (props: IUpdateTermHireDateDialogProps) => {
    const { register, errors, setValue, getValues } = useForm();
    const { post, response } = useFetch();
    const [toast, setToast] = useState<{ message: string; color?: string, persistent?: boolean; } | null>(null);

    const appContext = useContext<IAppContextState>(AppContext);
    const currentUser = {
        name: appContext.currentUser.username,
        id: appContext.currentUser.userId,
        lmsNumber: appContext.currentUser.lmsNumber
    };

    useEffect(() => {
        onCreate();
    }, []);

    useEffect(() => {
        setValue('oldDate', props.oldDate);
    }, [props.oldDate]);

    const onCreate = () => {
        console.log('UpdateTermHireDate onCreate()');
    };

    const showToast = (message: string, color?: string, persistent?: boolean) => {
        setToast({ message, persistent, color });
    };

    // on submit
    const addNewEntry = async () => {
        let data = new PersonnelHiringHistory();
        let newDate = getValues().newDate;

        // converting data for proper db storage
        data.lmNo = props.selectedPersonnel.lmNo;
        data.hireByNo = parseInt(currentUser.lmsNumber.toString(), 10);
        data.hireBy = currentUser.name;
        data.tranByNo = parseInt(currentUser.lmsNumber.toString(), 10);
        data.tranBy = currentUser.name;
        data.tranDate = new Date(newDate);
        data.timestamp = new Date().toISOString();
        data.tranType = props.context === 'Termination' ? 'T' : (props.context === 'Rehire' ? 'H' : 'n/a'); // default n/a to indicate something went wrong
        data.notes = '';

        let result = await post(`/v1.0/landmen/personnel/create-hire-history`, data);
        if (response.ok) {
            showToast('Hiring history created successfully');
            closeDialog();
        } else {
            console.log('error with post: ', response);
            showToast('Unable to create hiring history: ' + result.message, `rgba(255,0,0,0.5)`);
        }
    };

    const closeDialog = async () => {
        props.hideDialog();
    };

    return (
        <Dialog title={`Update ${props.context} Date`} dialogName={props.dialogName} isExitButtonInvisible={false} bodyStyle={{ width: '25%' }}>
            <div>
                {toast && (
                    <PersonnelToast
                        message={toast.message}
                        color={toast.color}
                        onClose={() => setToast(null)}
                        persistent={toast.persistent}
                    />
                )}
            </div>
            <div>
                <form>
                    <div>
                        <RHFInputBox
                            label={`Old ${props.context} Date`}
                            name={`oldDate`}
                            type="date"
                            register={register}
                            errors={errors}
                            style={{ width: '100%' }}
                            bodyStyle={{ width: '50%' }}
                            labelOnLeft={true}
                            disabled={true}
                        />
                        <RHFInputBox
                            label={`New ${props.context} Date`}
                            name={`newDate`}
                            type="date"
                            register={register}
                            errors={errors}
                            style={{ width: '100%' }}
                            bodyStyle={{ width: '50%' }}
                            labelOnLeft={true}

                        />
                    </div>
                    <div className="form-row" style={{ marginTop: '2rem', marginLeft: '33%', textAlign: 'center' }}>
                        <Button
                            className="blue-hover-button"
                            intent="primary"
                            style={{ width: '24%', marginRight: '1rem' }}
                            text={'Update'}
                            onClick={() => addNewEntry()}
                        />
                        <Button
                            className="blue-hover-button"
                            intent="secondary"
                            style={{ width: '24%', marginRight: '1rem' }}
                            text={'Cancel'}
                            onClick={() => props.hideDialog()}
                        />
                    </div>
                </form>
            </div>
        </Dialog>
    );
};

export default UpdateTermHireDateDialog;



// WEBPACK FOOTER //
// ./src/components/personnel/dialogs/UpdateTermHireDateDialog.tsx